export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_11.97784ed4.jpg";